import { BaseModel } from "../../Bases/BaseModel";
import { OperacaoFiltroAcesso } from "./OperacaoFiltroAcesso";

export class Operacao extends BaseModel {
    constructor(
        public operacao_id = 0,
        public descricao = '',
        public observacao = '',
        public empresa_vinculada_id = 0,
        public operacaoFiltroAcesso = new OperacaoFiltroAcesso(),
    ) {
        super();
    }
}

